<div id="conteudo-geral" class="conteudo-geral">
  <router-outlet></router-outlet>
</div>
